export const navList = [
    {
        name: '综合',
        path: '/',
        icon: 'el-icon-s-home',
        code: 'home'
    },
    {
        name: '文库',
        path: '/article',
        icon: 'el-icon-s-management',
        code: 'article'
    },
    {
        name: '话题夹',
        path: '/talk',
        icon: 'el-icon-s-comment',
        code: 'talk'
    },
    // {
    //     name: '图片墙',
    //     path: '/picture',
    //     icon: 'el-icon-picture',
    //     code: 'picture'
    // },
]

export const compositeType = [
    {
        value: 'charhoo_article',
        label: '文章',
        color: '#409EFF',
        gradientColor: 'linear-gradient(to right, #748AF7, #95A2FB)',
    },
    {
        value: 'charhoo_talk_article',
        label: '话题',
        color: '#4C83FC',
        gradientColor: 'linear-gradient(to right, #4C83FC, #79BBFF)',
    },
    // {
    //     value: 'charhoo_picture',
    //     label: '图片',
    //     color: '#67C23A',
    //     gradientColor: 'linear-gradient(to right, #67C23A, #97e96d)',
    // },
]

export const articleTitleType = [
    'header1',
    'header2',
    'header3',
    'header4',
    'header5',
    'list-item',
]

export const jumpData = {
    bilibili: 'https://space.bilibili.com/3546654084958440?spm_id_from=333.337.0.0',
    aifadian: 'https://afdian.com/a/huanlong',
    complaint: 'https://docs.qq.com/form/page/DT2Z0WXBqZlVFUm5E',
}

export const panelData = {
    webUrl: {
        title: '网站应用',
        list: [
            {
                name: '茶狐主站',
                url: 'https://charhoo.cn/',
                cover: 'https://charhoo.cn/file/202407/4bc0786f55194f4380e9160047e7ff5d.png',
            },
            {
                name: 'MC藏宝阁',
                url: 'https://mcbank.charhoo.cn/',
                cover: 'https://charhoo.cn/file/202407/56b0446528a44405ae4b678aaad0bcad.png',
            },
            {
                name: '茶狐导航',
                url: 'https://charhoo.cn/nav/home',
                cover: 'https://charhoo.cn/file/202407/c222c319ea5c41e4a781f3194928adf7.png',
            },
        ]
    },
    aifadian: 'https://afdian.com/a/huanlong'
}